import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { Mt5, Mr5, GenericWrapper, FlexCenterWrapper } from 'wrappers';
import { DeleteIconButton } from 'atoms';
import { CustomDropdown } from 'containers';
import { Icon } from 'atoms';
import { DocumentSvg, DollarSignSvg } from 'components/icons';
import { InputError, InputWithIcon } from 'molecules';
import getIsMobile from 'components/atoms/utils/getIsMobile';
import internalState from './internalState';
import PurchaseOrderCategoryBudget from '../purchaseOrderCategoryBudget';

const isMobile = getIsMobile();

export const definition = ({
  controller: Controller,
  name: "Category",
  initialProps: ({ categories, category, displayDelete }) => ({ categories, category, displayDelete }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(FlexCenterWrapper, Mt5),
      name: 'FieldsWrapper',
      elements: [
        {
          wrapper: wrap(GenericWrapper, Mr5),
          name: 'AmountWrapper',
          elements: [
            {
              component: InputWithIcon,
              name: "Amount",
              bindings: ({ category, localValue }) => ({ category, value: localValue, placeholder: "Amount", icon: DollarSignSvg({ width: 18, height: 18 }) }),
              displayState: ({ }) => ({ width: '200px' })
            },
            {
              component: InputError,
              name: 'AmountError',
              renderIf: ({ category }) => category.amountError,
              bindings: ({ category }) => ({ error: category.amountError })
            },
          ]
        },
        {
          wrapper: GenericWrapper,
          name: 'CategoryWrapper',
          elements: [
            {
              component: CustomDropdown,
              name: 'Dropdown',
              bindings: ({ category, categories }) => ({
                category,
                label: { values: [DocumentSvg({ width: 16, height: 16, color: window?.settings?.primary_color ?? '#1DBD6B' })], keys: ['icon'], component: Icon },
                selectedOptionIds: category.category_id ? [category.category_id] : [],
                placeholder: 'Category',
                hasSearch: true,
                options: categories.map(cat => ({ id: cat.id, display: cat.name })),
                openOnTop: isMobile
              })
            },
            {
              component: InputError,
              name: 'CategoryError',
              renderIf: ({ category }) => category.category_idError,
              bindings: ({ category }) => ({ error: category.category_idError || '' })
            },
          ]
        },
        {
          component: DeleteIconButton,
          name: 'Delete',
          renderIf: ({ displayDelete }) => displayDelete,
          bindings: ({ }) => ({})
        },
      ]
    },
    {
      component: wrap(PurchaseOrderCategoryBudget, Mt5),
      name: 'Budget',
      renderIf: ({ category }) => !!category.category_id,
      bindings: ({ categories, category }) => ({ category: categories.find(c => c.id === category.category_id), currentAmount: category.amount ?? 0 })
    }
  ],
})

export default ContainerComponent(definition);
